module.exports = __webpack_public_path__ + "img/cashbox.0edea9e5.svg";